import { render, staticRenderFns } from "./ListAndAdd.vue?vue&type=template&id=6ae3bb72&"
import script from "./ListAndAdd.vue?vue&type=script&lang=js&"
export * from "./ListAndAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports